<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mc3pag/tc-custom/9780310561019.jpg?1726454431719" alt="This image is the cover for the book Countdown in Cairo, The Russian Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Countdown in Cairo, The Russian Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>When federal agent Alexandra LaDuca travels to Egypt to investigate the possible sighting of a former mentor, she is thrown into the deadliest game of double cross in her career. An American woman working alone, she must rely on her wits, her training, and her skill with lethal weapons not just to succeed, but also to survive. A CIA agent whom she believed to be dead appears to be alive; and why is he dressing like an Arab and speaking Russian? Tough, savvy, and cool under fire, Alex pushes herself to the limits as she puts her life on the line once again for her faith and her country—all while working with a mysterious new partner who may or may not be trustworthy. This fast-paced contemporary espionage thriller is exactly what Noel Hynd fans have been waiting for, the third and final installment of the Russian Trilogy. It will keep everyone turning pages and guessing from beginning to end.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Noel Hynd
      </h2>
      
      <p class="authorDescription body article"><P>Noel Hynd has sold more than four million copies of his books throughout the world, including <I>The Enemy Within</I> and <I>Flowers From Berlin</I>.&#160; His most recent novel, <I>Hostage in Havana</I>, is the first book in the Cuban Trilogy starring Alexandria LaDuca.&#160; Hynd lives in Culver City, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6970630